import { SITE_CONFIG } from '../config/site-config';

export function addressBlock(includeCountry = true): string {
  const a = SITE_CONFIG.ADDRESS;
  const country = includeCountry ? `<br>${a.country}` : '';
  return `<address>${SITE_CONFIG.LEGAL_NAME}<br>${a.street}<br>${a.city}, ${a.region} ${a.postalCode}${country}</address>`;
}

export function addressLine(): string {
  const a = SITE_CONFIG.ADDRESS;
  return `${SITE_CONFIG.LEGAL_NAME}, ${a.street}, ${a.city}, ${a.region} ${a.postalCode}, ${a.country}`;
}
